import * as React from 'react'
import cx from 'classnames'
import Toggle from '@src/components/common/toggle'
import * as styles from '../../monitoring.summary.styl'
import confirm from '@src/utils/confirm'
import { ColumnType, ColumnProps, GridAction } from '@src/components/data.grid'
import type { Monitoring } from '@src/redux/reducers'
import { AlertSeverityEnum } from '@src/endpoints/services/commonHdr.service'

interface GetColumnsOptions {
  onOpen?: (data: Monitoring.GuardrailInfo) => void
}

export const getGuardrailColumns = ({
  onOpen
}: GetColumnsOptions): ColumnProps<Monitoring.GuardrailInfo>[] => [
  {
    type: ColumnType.severity,
    field: 'severity',
    severityOptions: {
      high: row =>
        row?.original.severity === AlertSeverityEnum.ALERT_SEVERITY_HIGH,
      medium: row =>
        row?.original.severity === AlertSeverityEnum.ALERT_SEVERITY_MEDIUM,
      low: row =>
        row?.original.severity === AlertSeverityEnum.ALERT_SEVERITY_LOW
    }
  },
  { type: ColumnType.selector },
  {
    title: 'Name',
    field: 'name',
    clickable: data => !data.auto_create,
    onClick: data => onOpen(data),
    width: 410
  },
  {
    title: 'Last Alert',
    field: 'last_alert_date',
    type: ColumnType.datetime
  },
  {
    title: 'Created On',
    field: 'create_date',
    type: ColumnType.datetime
  },
  {
    title: 'Alerts',
    width: 90,
    field: 'failed_count'
  },
  {
    title: 'Created By',
    field: 'user_id'
  },
  {
    title: 'Query',
    field: 'query'
  }
]

export function getGridActions(
  onShowDetails: (data: Monitoring.GuardrailInfo) => void,
  onDeleteMonitor: (id: string) => void,
  onPatchMonitors: (items: Monitoring.GuardrailInfo[], enable: boolean) => void
): GridAction<Monitoring.GuardrailInfo>[] {
  return [
    {
      handler: (data: Monitoring.GuardrailInfo) =>
        confirm({
          message: 'Are you sure want to delete guardrail?',
          onSuccess: () => {
            onDeleteMonitor(data.monitor_id)
          }
        }),
      template: row => <i className={'material-icons'}>delete</i>,
      title: 'Delete Guardrail'
    },
    {
      handler: data => onPatchMonitors([data], true),
      multipleHandler: items => onPatchMonitors(items, true),
      template: row => (
        <Toggle
          className={cx(styles.onOffMonitor, 'onOffMonitor')}
          on={false}
        />
      ),
      title: 'Enable',
      description: 'Enable Alerting',
      hide: data => data.alerts_enabled
    },
    {
      handler: data => onPatchMonitors([data], false),
      multipleHandler: items => onPatchMonitors(items, false),
      template: row => (
        <Toggle className={cx(styles.onOffMonitor, 'onOffMonitor')} on />
      ),
      title: 'Disable',
      description: 'Disable Alerting',
      hide: data => !data.alerts_enabled
    },
    {
      handler: data => onShowDetails(data),
      template: row => <i className={'material-icons'}>visibility</i>,
      title: 'View Details'
    }
  ]
}
